module.exports = __webpack_public_path__ + "static/media/female-hedge-cutting.bf37e70e.svg";